import { Center, Text } from '@chakra-ui/react';

interface MessageBlockProps {
  errorMessage?: string;
  state: 'loading' | 'error' | 'success' | 'empty' | 'noEntry';
}

const NoEntryMessage = () => (
  <Text fontSize="md" color="textSubdued">
    Type a keyword <br />
    to get started
  </Text>
);

const ErrorMessage = ({ errorMessage }: { errorMessage: string }) => (
  <Text fontSize="md" color="textSubdued" px={2}>
    {errorMessage}
  </Text>
);

const EmptyMessage = () => (
  <Center>
    <Text fontSize="md" color="textSubdued">
      No Results found
    </Text>
  </Center>
);

export const MessageBlock = ({ errorMessage, state }: MessageBlockProps) => {
  if (errorMessage) {
    return <ErrorMessage errorMessage={errorMessage} />;
  }

  if (state === 'noEntry') {
    return <NoEntryMessage />;
  }

  if (state === 'empty') {
    return <EmptyMessage />;
  }

  return null;
};
